export default "__VITE_ASSET__CBJ$NIr2__"